<template>

  <div id="app">
    <link href="https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/css/line-awesome.min.css"
          rel="stylesheet">
    <ModulesPageFormulaire></ModulesPageFormulaire>
  </div>
</template>

<script>
  import ModulesPageFormulaire from '@/components/modules/ModulesPageFormulaire';

  export default {
  name: 'app',
    components: {ModulesPageFormulaire},
}
</script>

<style>
  * {
    box-sizing: border-box;
  }

  html, body {
    overscroll-behavior-y: contain;
    font-size: 1rem;
  }

  @media screen and (min-width: 960px) {
    html, body {
      overscroll-behavior-y: contain;
      font-size: 1.1rem;
    }
  }


  @media screen and (max-width: 500px) {
    html, body {
      overscroll-behavior-y: contain;
      font-size: 0.9rem;
    }
  }

  @media screen and (max-width: 360px) {
    html, body {
      overscroll-behavior-y: contain;
      font-size: 0.7rem;
    }
  }

  html {
    height: 100%;
  }

  body {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin: 0;
    padding: 0;
    height: 100%;
    background: white;
  }

  #app {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    overflow: hidden;
  }
</style>
